<template>
  <div class="index">
    <div class="contain">
      <!-- 轮播图 -->
      <el-carousel class="top-carousel">
        <el-carousel-item
          v-for="(item,index) in adverList"
          :key="index"
          class="carousel-img-outer common-img-outer"
        >
          <!-- 为0跳h5 -->
          <a :href="item.urlLink" v-if="item.dictId == '0'">
            <img :src="$store.state.imgUrl+item.urlImage" alt/>
          </a>
          <img
            :src="$store.state.imgUrl+item.urlImage"
            alt
            @click="getAdverDetail(item.dictId,item.skipId,item.show)"
            v-else
          />
        </el-carousel-item>
      </el-carousel>
      <!-- 标题 中医自测 -->
      <el-row class="Headline">
        <el-col :span="24" class="Headline-ch">中医自测</el-col>
        <el-col :span="24" class="Headline-en">Self diagnosis of TCM</el-col>
      </el-row>
      <!-- 自测内容块 -->
      <el-row class="self-diagnosis-content">
        <el-col :span="10" class="left-img">
          <img src="../assets/img/1.png" alt/>
        </el-col>
        <el-col :span="14" class="right-word">
          <div class="flow-path">
            添加医案
            <img src="../assets/img/jianou-right1.png" alt/>主要症状
            <img src="../assets/img/jianou-right1.png" alt/>详细症状
            <img src="../assets/img/jianou-right1.png" alt/>自测分析
          </div>
          <div class="line"></div>
          <div class="zz-introduction">
            中医自测是我国历代医家几千年来诊断疾病的宝贵经验的积累,在我国有着
            悠久的历史。在古代,中医利用望闻问切诊断疾病
          </div>
          <div class="button" @click="zizhen()">立即诊断</div>
        </el-col>
      </el-row>
      <el-row style="margin:40px 0px 20px" v-if="!!adverA">
        <el-col :span="24">
          <div class="adver-outer-img common-img-outer setPositon">
            <a :href="adverAurl">
              <img :src="$store.state.imgUrl+adverA" alt style="width:100%"/>
              <span class="adver-words-tip" v-if="adverA">{{ adverWordsTip }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
      <!-- 标题 中医讲堂 -->
      <el-row class="Headline">
        <el-col :span="24" class="Headline-ch">中医讲堂</el-col>
        <el-col :span="24" class="Headline-en">Chinese Medicine Lecture Hall</el-col>
      </el-row>
      <!-- 讲堂内容 -->
      <el-row class="forum">
        <el-col :span="18" class="forum-left">
          <div
            class="form-left-wrap shou"
            @click="jiangtangV(item.type,item.id)"
            v-for="(item,index) in jiantangFirst"
            :key="index"
          >
            <div class="video-outer common-img-outer">
              <img
                :src="$store.state.imgUrl+item.stanceImg"
                alt
                style="width:100%"
                v-if="item.type == '1'"
              />
              <!-- <span>{{item.videoFile}}</span> -->
              <video :src="$store.state.imgUrl+item.videoFile" controls 
                :ref="'videoRefs'+index" @play="pauseOtherVideos(index)"
              :poster="$store.state.imgUrl+item.stanceImg" v-else></video>
            </div>
            <div class="forum-left-title">{{ item.name }}</div>
            <div class="forum-left-lecturer">讲师：{{ item.author }}</div>
            <div class="forum-left-lecturer-hall" v-html="limitMaxWords(96, item.jianshu)"></div>
          </div>
        </el-col>
        <el-col :span="6" class="forum-right clearfix">
          <div class="forum-list clearfix">
            <div
              @click="jiangtangV(item.type,item.id)"
              v-for="(item,index) in jiantangList"
              :key="index"
              class="shou shou2"
            >
              <div class="forum-list-title">{{ item.name }}</div>
              <div class="forum-list-lecturer">讲师：{{ item.author }}</div>
              <div class="forum-list-lecturer-hall"  v-html="limitMaxWords(14, item.jianshu)"></div>
              <div class="video-img-outer common-img-outer">
                <img
                  :src="$store.state.imgUrl+item.stanceImg"
                  alt
                  style="width:100%"
                  v-if="item.type == '1'"
                />
                <video :src="$store.state.imgUrl+item.videoFile" controls   :ref="'videoRefs2'+index"
                @play="pauseOtherVideos2(index)"
                controlslist="nodownload disablePictureInPicture nofullscreen noremoteplayback" 
                disablePictureInPicture="true" :poster="$store.state.imgUrl+item.stanceImg" 
                v-else></video>
              </div>
              <div class="list-line"></div>
            </div>
            <div class="view-more shou" @click="jiangtang()">查看更多</div>
          </div>
        </el-col>
      </el-row>
      <!-- 中草药 -->
      <div class="herbal-medicine">
        <!-- 标题 中草药 -->
        <el-row class="Headline">
          <el-col :span="24" class="Headline-ch">中草药</el-col>
          <el-col :span="24" class="Headline-en">Chinese herbal medicine</el-col>
        </el-row>
        <!-- 中草药内容 -->
        <el-row :gutter="20" class="herbal-list">
          <el-col :span="6" v-for="(item,index) in zhongcaoyaoList" :key="index">
            <div @click="zhongcaoyaoD(item.id)" class="shou">
              <div class="img-outer common-img-outer">
                <img src="../assets/img/suolue.jpg" alt="" v-if="!item.photoUrl">
                <img :src="$store.state.imgUrl+item.photoUrl" alt v-if="item.photoUrl"/>
              </div>
              <div class="herbal-name">{{ item.atName }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row class="center-more">
          <el-col :span="24">
            <div class="view-more shou" @click="zhongcaoyao()">查看更多</div>
          </el-col>
        </el-row>
      </div>
      <!-- 标题 中医文库 -->
      <el-row class="Headline">
        <el-col :span="24" class="Headline-ch">中医文库</el-col>
        <el-col :span="24" class="Headline-en">TCM Library</el-col>
      </el-row>
      <!-- 中医文库内容 -->
      <el-row class="flexJ">
        <el-col v-for="(item, index) in wenkuList" :key="index" class="wenku">
          <div @click="wenkuD(item.id)" class="shou">
            <el-card class="box-card">
              <div class="one-book">
                <img
                  src="../assets/img/13.png"
                  alt
                  style="width:100%"
                  v-if="index == '0'"
                />
                <img
                  src="../assets/img/14.png"
                  alt
                  style="width:100%"
                  v-if="index == '1'"
                />
                <img
                  src="../assets/img/15.png"
                  alt
                  style="width:100%"
                  v-if="index == '2'"
                />
                <img
                  src="../assets/img/16.png"
                  alt
                  style="width:100%"
                  v-if="index == '3'"
                />
                <img
                  src="../assets/img/13.png"
                  alt
                  style="width:100%"
                  v-if="index == '4'"
                />

                <div
                  class="one-book-title-box start-left-right-end-shu"
                >{{ item.name }}
                </div>
              </div>
              <div class="book-detail">
                <div class="top-title">
                  {{ limitMaxWords(5, item.name) }}
                  <span
                    class="author"
                  >{{ item.author }}</span>
                </div>
                <div class="summary">{{ item.zhaiyao }}</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row class="center-more">
        <el-col :span="24">
          <div class="view-more shou" @click="wenku()">查看更多</div>
        </el-col>
      </el-row>
      <el-row style="margin:40px 0px 20px" v-if="!!adverB">
        <el-col :span="24">
          <div class="adver-outer-img common-img-outer setPositon">
            <a :href="adverBurl">
              <img :src="$store.state.imgUrl+adverB" alt style="width:100%"/>
              <span class="adver-words-tip" v-if="adverB">{{ adverWordsTip }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
      <!-- 标题 经络穴位 -->
      <el-row class="Headline">
        <el-col :span="24" class="Headline-ch">经络穴位</el-col>
        <el-col :span="24" class="Headline-en">Meridians and acupoints</el-col>
      </el-row>
      <!-- 经络穴位内容 -->
      <!-- <el-carousel :interval="5000" arrow="always" class="acupoint"> -->
      <el-carousel  :autoplay="false" class="acupoint jingXueCarousel" trigger="click">
        <el-carousel-item v-for="(item, index) in jingXueList" :key="index">
          <el-row>
            <el-col :span="11">
              <div class="block shou imgWrap" @click="jingluoD(item.id)">
                <img
                  style="width: 320px;"
                  :src="$store.state.imgUrl+item.jltj[0]"
                >
              </div>
            </el-col>
            <el-col :span="13">
              <div class="acupoint-title">{{ item.name }}</div>
              <div class="acupoint-line"></div>
              <div class="acupoint-introduction" v-html="item.gaishu"></div>
              <div class="tag-list" style="margin-top:20px;">
                <el-tag
                  @click="xueweiD(item1.id)"
                  type="info"
                  v-for="(item1,index1) in item.acupointList"
                  :key="index1"
                  class="shou"
                  v-show="index1<15"
                >{{ item1.name }}
                </el-tag>
                <el-tag
                type="info"
                class="shou"
                @click="jingluoD(item.id)"
                v-show="item.acupointList.length>15"
              >...</el-tag>
              </div>
              <div class="view-detail shou" @click="jingluoD(item.id)">查看详情</div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
      <el-row class="center-more acupoint-more">
        <el-col :span="24">
          <div class="view-more shou" @click="jingxue()">查看全部</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      adverList: [], //轮播图
      zhongcaoyaoList: [], //接收中草药
      jiantangFirst: [], //左侧显示的讲堂
      jiantangList: [], //右侧讲堂列表
      wenkuList: [], //文库列表
      jingXueList: [], //经络穴位
      seachInput: "",
      routers: []
    };
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
    },

    // 讲堂列表
    jiangtang() {
      this.$router.push({
        path: "/ForumIndex"
      });
    },
    //中草药列表
    zhongcaoyao() {
      this.$router.push({
        path: "/HerbalMedicineIndex"
      });
    },
    //中草药详情
    zhongcaoyaoD(id) {
      this.$router.push({
        path: "/HerbalMedicineDetail",
        query: {id: id}
      });
    },
    //文库列表
    wenku() {
      this.$router.push({
        path: "/LibraryIndex"
      });
    },
    //文库详情
    wenkuD(id) {
      this.$router.push({
        path: "/weiKuDetail",
        query: {id: id}
      });
    },
    //经络穴位列表页
    jingxue() {
      this.$router.push({
        path: "/JingLuoIndex"
      });
    },
    //经络详情
    jingluoD(id) {
      this.$router.push({
        path: "/JingLuoDetail",
        query: {id: id}
      });
    },
    // 获得中草药
    getZhongcaoyao() {
      let that = this;
      let url = "/ypgl/getYpglByOfficial";
      that.$http
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            that.zhongcaoyaoList = [];
            that.zhongcaoyaoList = res.data.data.map(
              (item, index) => {
                return {
                  atName: item.atName,
                  photoUrl: item.photoUrl?item.photoUrl.split(',')[0]:'',
                  id: item.id
                };
              }
            );
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //获得轮播图
    getCarousel() {
      let that = this;
      let url = "/news/getBySeatId";
      let params = {
        seatId: 2
      };
      that.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            that.adverList = [];
            that.adverList = res.data.data;
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    // 获得讲堂
    getJiangtang() {
      let that = this;
      let url = "/medicineForum/getMedicineForumByOfficial";
      that.$http
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.jiantangList = [];
            that.jiantangFirst = [];
            for (let i = 0; i < arr.length; i++) {
              if (i == 0) {
                // 左侧的
                that.jiantangFirst.push({
                  author: arr[i].author,
                  jianshu: arr[i].jianshu,
                  name: arr[i].name,
                  stanceImg: arr[i].stanceImg,
                  type: arr[i].type,
                  id: arr[i].id,
                  videoFile: arr[i].videoFile
                });
              } else {
                // 右侧的两个
                that.jiantangList.push({
                  author: arr[i].author,
                  jianshu: arr[i].jianshu,
                  name: arr[i].name,
                  stanceImg: arr[i].stanceImg,
                  type: arr[i].type,
                  id: arr[i].id,
                  videoFile: arr[i].videoFile
                });
              }
            }
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    pauseOtherVideos(currentIndex){
      this.jiantangFirst.forEach((video, index) => {
        if (index !== currentIndex) {
          this.$refs['videoRefs'+index][0].pause()   // 暂停其他视频
        } else {
          this.$refs['videoRefs'+index][0].play() // 播放当前视频
        }
      });
      this.jiantangList.forEach((video, index) => {
        this.$refs['videoRefs2'+index][0].pause()   // 暂停其他视频
      }); 
    },
    pauseOtherVideos2(currentIndex){ 
      this.jiantangList.forEach((video, index) => {
        if (index !== currentIndex) {
          this.$refs['videoRefs2'+index][0].pause()   // 暂停其他视频
        } else { 
          this.$refs['videoRefs2'+index][0].play() // 播放当前视频
        }
      });
      this.jiantangFirst.forEach((video, index) => {
        this.$refs['videoRefs'+index][0].pause()   // 暂停其他视频
      }); 
    },
    // 获得文库
    getWenku() {
      let that = this;
      let url = "/medicineLibraryBooks/getMedicineLibraryBooksByOfficial";
      that.$http
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            that.wenkuList = [];
            that.wenkuList = res.data.data.map((item, index) => {
              return {
                id: item.id,
                author: item.author,
                name: item.name,
                zhaiyao: that.limitMaxWords(20, item.zhaiyao),
                stanceImg: item.stanceImg
              };
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //获得经络穴位
    getJingXue() {
      let that = this;
      let url = "/jlxw/meridians/getAcupointByOfficial";
      that.$http
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            that.jingXueList = [];
            that.jingXueList = res.data.data.map((item, index) => {
              let urls = [];
              if (item.jltj) {
                if (item.jltj.charAt(0) === ',') {
                  item.jltj = item.jltj.substring(1);
                }
                if (item.jltj.charAt(item.jltj.length - 1) === ',') {
                  item.jltj = item.jltj.slice(0, -1);
                }
                urls = item.jltj.split(",");
              } else {
                urls = [];
              }
              return {
                id: item.id,
                jltj: urls,
                name: item.name,
                gaishu: item.gaishu,
                acupointList: item.acupointList
              };
            });
          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    },
    //穴位详情
    xueweiD(id) {
      this.$router.push({
        path: "/xueWeiDetail",
        query: {id: id}
      });
    },

    //轮播图跳转
    getAdverDetail(type, id, show) {
      console.log('type', type)
      if (show == '0') {
        //授权到期后者停用
        return false
      }
      if (type == "1") {
        //商品
        this.$router.push({path: "/ProductDetails/" + id});
      }
      if (type == "3") {
        //视频讲堂
        this.$router.push({
          path: "/ForumDetailv",
          query: {type: "0", id: id}
        });
      }
      if (type == "4") {
        //图文讲堂
        this.$router.push({
          path: "/ForumDetailw",
          query: {type: "1", id: id}
        });
      }
      if (type == "5") {
        //经络
        this.$router.push({
          path: "/JingLuoDetail",
          query: {id: id}
        });
      }
      if (type == "6") {
        //穴位
        this.$router.push({
          path: "/xueWeiDetail",
          query: {id: id}
        });
      }
      if (type == "7") {
        //文库
        this.$router.push({
          path: "/weiKuDetail",
          query: {id: id}
        });
      }
      if (type == "8") {
        //自测
        if (!this.isLoginF()) return false;
        this.$router.push({
          path: "/myYiAn"
        });
      }
      if (type == "9") {
        //问卷调查
        if (!this.isLoginF()) return false;
        const routeData = this.$router.resolve({ path: '/questionnaire', query: { id: 'id' }})
        window.open(routeData.href, '_blank')
      }
    }
  },
  created() {
    let that = this;
    this.routers = this.$router.options.routes[0].children;
    that.getCarousel(); //轮播图
    that.getPositionAdver(0, 3); //首页A位置广告
    that.getPositionAdver(1, 3); //首页B位置广告
    that.getJiangtang(); //讲堂
    that.getZhongcaoyao(); //中草药
    that.getWenku(); //文库
    that.getJingXue(); //经络穴位
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-tag+.el-tag{
margin-left: 0!important;
}
.shou2 video::-webkit-media-controls-fullscreen-button {
    display: none;
    }
.shou2 video::-webkit-media-controls-timeline {
    display: none;
    }
.shou2 video::-webkit-media-controls-current-time-display{
    display: none;
    }
.shou2 video::-webkit-media-controls-time-remaining-display {
    display: none;
    }
.shou2 video::-webkit-media-controls-mute-button {
    display: none;
    }
.shou2 video::-webkit-media-controls-toggle-closed-captions-button {
    display: none;
    }
.shou2 video::-webkit-media-controls-volume-slider {
    display: none;
    }
    /* 隐藏seeking手柄 */
.shou2 video::-webkit-media-controls-seek-forward-button {
      display: none;
    }
.shou2 video::-webkit-media-controls-seek-back-button {
      display: none;
    }
 
.video-img-outer {
  width: 100%;
  height: 116px;
}

.video-outer {
  width: 100%;
  height: 404px;
}

.adver-outer-img {
  width: 100%;
  height: 120px;
}

.carousel-img-outer {
  width: 1024px;
  /* height: 355.55px; */
}

.img-outer {
  width: 225.14px;
  height: 160.59px;
}

#searchButton {
  background-color: #f64420;
  color: white;
  padding: 8px 10px;
  border-radius: 0px;
}

.head-title {
  font-size: 12px;
  line-height: 40px;
  letter-spacing: 1.9px;
  color: #ffffff;
  opacity: 0.4;
}

.top-head {
  width: 100%;
  height: 40px;
  background-color: #333333;
}

.top-head .el-col,
.top-head .el-row {
  height: 100%;
}

.el-menu-black > .el-menu-item {
  line-height: 40px;
  height: 40px;
  opacity: 0.4;
  font-size: 12px;
}

.el-menu-black {
  line-height: 40px;
  height: 40px;
  float: right;
}

.el-menu-white {
  width: 650px;
  border: none;
  float: right;
}

.bottom-head {
  padding: 20px 0px;
}

.head-logo {
  max-height: 60px;
}

.head-logo img {
  display: block;
  height: 60px;
}

/* header .el-input-group {
    width: 252px;
    margin-top: 15px;
    float: right;
} */
.acupoint-more {
  margin: 0px auto 30px;
}

.acupoint {
  /* width: 1115px; */
  /* margin: 0px auto; */
  height: 400px;
}

.acupoint .view-detail {
  width: 120px;
  height: 32px;
  background-color: #e0b76d;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  letter-spacing: 1.4px;
  color: #ffffff;
  /* margin-top: 50px; */
  cursor: pointer;
}

.acupoint-introduction {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1.4px;
  color: #666666;
  text-overflow: -o-ellipsis-lastline!important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;  
  line-clamp: 3!important;
  -webkit-box-orient: vertical;
}

.acupoint-title {
  font-size: 20px;
  letter-spacing: 2px;
  color: #333333;
}

.acupoint-line {
  width: 484px;
  height: 1px;
  background-color: #dddddd;
  margin: 30px 0px;
}

.acupoint .el-col-11 {
  padding-left: 80px;
}

.acupoint .el-col-13 {
  padding-right: 80px;
  margin: 80px 0px 30px;
}

/* .acupoint {
    width: 1115px;
} */
.one-book-title-box {
  /* width: 18%; */
  height: 120px;
  padding: 10px 0px;
  background-color: #ffffff;
  border: solid 1px #6c6b69;
  font-size: 22px;
  /* line-height: 40px; */
  letter-spacing: 4px;
  color: #444444;
  position: absolute;
  top: 22%;
  left: 34%;
  text-align: center;
  word-wrap: break-word;
  word-break: normal;
}

.one-book {
  /* width: 272px; */
  /* height: 340px; */
  position: relative;
}

.box-card {
  background-repeat: no-repeat;
}

/* .box-card:nth-child(1) {
    background-image: url("../assets/img/13.png");
} */
/* .box-card:nth-child(2) {
    background-image: url("../assets/img/14.png");
}
.box-card:nth-child(3) {
    background-image: url("../assets/img/15.png");
}
.box-card:nth-child(4) {
    background-image: url("../assets/img/16.png");
}
.box-card:nth-child(5) {
    background-image: url("../assets/img/13.png");
} */
.el-card {
  /* width: 272px; */
  /* width: 18.5%; */
  float: left;
}

.book-detail {
  padding: 10px;
  min-height: 119px;
}

.book-detail .top-title {
  font-size: 18px;
  line-height: 50px;
  letter-spacing: 1.8px;
  color: #333333;
}

.book-detail .author {
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 1.4px;
  color: #666666;
}

.book-detail .summary {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1.4px;
  color: #999999;
}

/* .el-card:not(:last-child) {
    margin-right:1%;
} */
.herbal-medicine .Headline {
  padding: 30px 0px;
}

.center-more .view-more {
  width: 192px;
  height: 40px;
  line-height: 40px;
  margin: 20px auto;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  font-size: 18px;
  text-align: center;
  letter-spacing: 1.8px;
  color: #555555;
  cursor: pointer;
  /* margin-top: 40px; */
}

.herbal-name {
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  letter-spacing: 3.5px;
  color: #666666;
}

/* .herbal-list > .el-col {
    width: 300px;
    margin: 0px 8px;
} */
.herbal-medicine {
  padding: 0px 3%;
}

.herbal-list > .el-col img {
  width: 100%;
}

.herbal-medicine {
  margin-top: 60px;
  /* height: 765px; */
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
}

.forum-left {
  padding-right: 50px;
}

.forum-right {
  padding-left: 50px;
}

.forum-right .view-more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  text-align: center;
  font-size: 18px;
  letter-spacing: 1.8px;
  color: #555555;
  float: right;
  cursor: pointer;
  margin-top: 20px;
}

/* .form-left-wrap {
    width: 920px;
} */
.forum-list-title {
  font-size: 16px;
  /* line-height: 30px; */
  /* letter-spacing: 1.6px; */
  color: #333333;
}

.forum-list .list-line {
  /* width: 320px; */
  height: 1px;
  background-color: #cccccc;
  margin: 20px 0px;
}

.forum-list-lecturer {
  font-size: 14px;
  /* line-height: 30px; */
  letter-spacing: 3.1px;
  color: #999999;
}

.forum-list-lecturer-hall {
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0px;
  color: #999999;
}

.forum-list video {
  width: 100%;
}

.forum-list {
  /* padding-left: 70px; */
  width: 100%;
  /* float: right; */
}

.el-carousel img {
  width: 100%;
  /* height: 100%; */
}

.Headline {
  text-align: center;
  padding: 20px 0px;
}

.Headline .Headline-ch {
  font-size: 26px;
  line-height: 50px;
  letter-spacing: 5.7px;
  color: #333333;
}

.Headline .Headline-en {
  font-size: 18px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #888888;
}

/* .self-diagnosis-content {
    width: 1000px;
    margin: 0px auto;
} */

.flow-path {
  width: 555px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  font-size: 18px;
  letter-spacing: 1.8px;
  color: #666666;
  position: absolute;
  top: 42px;
  left: -82px;
}

.flow-path img {
  vertical-align: middle;
  margin: 0px 17px;
}

.right-word {
  position: relative;
  padding-top: 100px;
  padding-left: 70px;
}

.line {
  width: 71px;
  height: 2px;
  margin: 30px 0px;
  background-color: #f64420;
}

.zz-introduction {
  /* width: 537px; */
  height: 45px;
  font-size: 16px;
  line-height: 23.3px;
  letter-spacing: 0.6px;
  color: #666666;
}

.button {
  width: 141px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 1.6px;
  color: #ffffff;
  background-color: #f64420;
  margin-top: 30px;
  cursor: pointer;
}

.forum-left video {
  width: 100%;
  height: 100%;
}

.forum-left {
  border-right: 1px solid #cccccc;
}

.forum-left-title {
  font-size: 18px;
  line-height: 50px;
  /* margin-top: 29px; */
  letter-spacing: 1.8px;
  color: #333333;
}

.forum-left-lecturer {
  font-size: 14px;
  line-height: 50px;
  letter-spacing: 3.1px;
  color: #999999;
}

.forum-left-lecturer-hall {
  font-size: 14px;
  line-height: 19.3px;
  letter-spacing: 0px;
  color: #999999;
}

.wenku {
  margin-right: 1%;
  width: 20%;
}

.wenku:last-child {
  margin-right: 0;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.flexJ {
  display: flex;
  flex: 1;
}
.imgWrap{
  height: 370px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 控制面板样式 */
.forum-left video::-webkit-media-controls-panel {
  background: linear-gradient(to bottom, transparent 80%, rgba(0,0,0,.3) 95%, rgba(0,0,0,.5)100%) !important;
} 
/* 控制面板样式 */
.forum-right video::-webkit-media-controls-panel {
  background: linear-gradient(to bottom, transparent 65%, rgba(0,0,0,.3) 85%, rgba(0,0,0,.5)100%) !important;
} 
</style>
<style>
.top-carousel .el-carousel__container {
  height: 356px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue